import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PopularServices.module.css';

const PopularServices = () => {
    // Define categories manually to group them logically
    const categories = [
        {
            title: 'Start A Business',
            icon: 'fas fa-rocket',
            services: [
                'Private Limited Company',
                'One Person Company',
                'Limited Liability Partnership',
                'Partnership'
            ]
        },
        {
            title: 'Government Registrations',
            icon: 'fas fa-id-card',
            services: [
                'GST Registration',
                'FSSAI Registration',
                'Udyam Registration',
                'Trademark Registration'
            ]
        },
        {
            title: 'Tax & Compliance',
            icon: 'fas fa-file-invoice-dollar',
            services: [
                'GST Filing',
                'ITR Filing',
                'TDS Return Filing',
                'Annual Compliance' // We might need to add this key
            ]
        }
    ];

    return (
        <section className={styles.section} id="popular-services">
            <div className="container">
                <div className={styles.header}>
                    <h4 className={styles.label}>Our Offerings</h4>
                    <h2 className={styles.title}>All Your Business Needs in One Place</h2>
                    <p className={styles.subtitle}>From incorporation to compliance, we have got you covered.</p>
                </div>

                <div className={styles.categoriesGrid}>
                    {categories.map((cat, idx) => (
                        <div key={idx} className={styles.categoryCard}>
                            <div className={styles.categoryHeader}>
                                <div className={styles.iconBox}>
                                    <i className={cat.icon}></i>
                                </div>
                                <h3 className={styles.categoryTitle}>{cat.title}</h3>
                            </div>
                            <ul className={styles.serviceList}>
                                {cat.services.map((serviceName, sIdx) => {
                                    const linkPath = `/service/${encodeURIComponent(serviceName)}`;

                                    return (
                                        <li key={sIdx} className={styles.serviceItem}>
                                            <Link to={linkPath} className={styles.serviceLink}>
                                                <i className="fas fa-check-circle"></i>
                                                <span>{serviceName}</span>
                                                <i className={`fas fa-chevron-right ${styles.arrow}`}></i>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PopularServices;
